import { snapshot } from 'valtio'
import store from '@/store'


const PRODUCT_API_URL = import.meta.env.VITE_API_URL_PRODUCT;


const getProductBySKU = async (sku:string) => {
	try {
		const {currentUser} = snapshot(store)
		let currentCompanyName = currentUser?.selectedCompany?.store_name
		const response = await fetch(`${PRODUCT_API_URL}/v2/public/products/?sku=${sku}&store_name=${currentCompanyName}&responseType=variant_selector`);
		const product = await response.json();
		return product.map( (item:any) => {
			item.product_profiles = (item?.product_profiles || [])?.sort((a:any, b:any) => a.order_index - b.order_index);
			return item;
		})

	} catch (err) {
		console.error("Error fetching product:", err);
		return null;
	}
}

export default getProductBySKU;
